const languageOptions = [
  {
    value: "en",
    label: "English"
  },
  {
    value: "ar",
    label: "Arabic"
  },
];

const fields = [
  "firstName",
  "lastName",
  "email",
  "cpUrl",
  "crmUrl",
  "clientName",
  "customerSupportName",
];

export { languageOptions, fields };
